import api from "../../../../../utils/axiosInstance";
import VendorScopedSection from "../shared/VendorScopedSection";
import VendorLanguagePairsTable from "./VendorLanguagePairsTable";
import EditLanguagePairPage from "./EditLanguagePairsPage";

const fetchData = async (vendorId) => {
  const res = await api.get(
    `/vendor-language-pairs/${vendorId}/language-pairs`,
    { withCredentials: true }
  );
  const data = res.data?.data;
  return {
    worksWithAll: data?.vendor?.works_with_all_language_pairs || false,
    items: data?.languagePairs || [],
  };
};

const onToggle = async (vendorId, newValue) => {
  if (!newValue) {
    await api.post("/vendor-language-pairs/initialize", {
      vendor_id: parseInt(vendorId),
    });
  }
  await api.put(
    `/vendor-settings/${vendorId}`,
    { works_with_all_language_pairs: newValue },
    { withCredentials: true }
  );
};

const VendorLanguagePairsPage = ({ vendorId }) => (
  <VendorScopedSection
    vendorId={vendorId}
    toggleLabel="Works with all language pairs:"
    helperText="This vendor works with all language pairs."
    sectionTitle="Language Pairs"
    containerMaxWidth="max-w-2xl"
    editModalTitle="Select Language Pairs"
    editModalMaxWidth="max-w-3xl"
    fetchData={fetchData}
    onToggle={onToggle}
    renderTable={({ items, worksWithAll }) => (
      <VendorLanguagePairsTable
        languagePairs={items}
        worksWithAll={worksWithAll}
      />
    )}
    renderEdit={({ onComplete }) => (
      <EditLanguagePairPage vendorId={vendorId} onUpdateComplete={onComplete} />
    )}
  />
);

export default VendorLanguagePairsPage;
